export enum UserType {
  Merchant = 'Merchant',
  Company = 'Company',
}
